import { configureStore } from '@reduxjs/toolkit';
import { quizzesSlice } from '../reducers/quizzes';
import { crosswordsSlice } from '../reducers/crosswords';
import { wordSearchesSlice } from '../reducers/word-searches';
const createStore = () => {
    const store = configureStore({
        reducer: {
            // Combined reducers configuration
            quizState: quizzesSlice.reducer,
            crosswordState: crosswordsSlice.reducer,
            wordSearchState: wordSearchesSlice.reducer,
        },
    });
    return store;
};
// // OR define it manually (if you prefer explicit types):
// export interface RootState {
//   quizState: QuizState;
//   crosswordState: CrosswordState;
// }
export { createStore };
